import usePersistedFlag from './usePersistedFlag';

export const NEVER_SHOW_SHOP_TO_CLUB = 'user_is_known_by_entered_email';

const useNeverShowShopToClub = (): [boolean, () => void] => {
    const [status, setStatus] = usePersistedFlag(NEVER_SHOW_SHOP_TO_CLUB, false);

    const neverShowShopToClub = !!status;
    const setNeverShowShopToClub = () => setStatus(1);

    return [neverShowShopToClub, setNeverShowShopToClub];
};

export default useNeverShowShopToClub;
